import React, { useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Skeleton, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import useIsMobile from "../../../../hooks/useIsMobile";
import ProductList from "./ProductList/ProductList";
import SearchBarProducts from "../SearchBar/SearchBarProducts";
import {
  modifyValueSearch,
  setSearchByName,
} from "../../../../Redux/Actions/searchActions";
import { isEmpty } from "lodash";
import { clickEvents, trackEvent } from "../../../../services/mixpanel";
import { getSupplierData } from "../../../../Redux/Selectors/appConfigSelector";
import DateInputContainer from "../../containers/DateInputContainer/DateInputContainer";
import { PERIODS, renderCustomFormatDate } from "../../../../helpers/tools";
import { addDays } from "date-fns";
import moment from "moment";
import { getSearchValueByKey } from "../../../../Redux/Selectors/searchSelectors";
import { isModoMono, isRental, RENTALS } from "../../../../helpers/rentals";
import {
  Container,
  NoProductsContainer,
  SkeletonContainer,
} from "./ProductsContainer.styles";
import { getBranchSelected } from "../../redux/selectors/ShopSelectors";

const { Paragraph } = Typography;

const ProductContainer = ({
  categories = [],
  productsByCategory,
  quoteSummary,
  handleOnSubstractProduct,
  handleOnAddProduct,
  handleOnDetailsClick,
  isLoading,
  isClosed,
  itemsLength,
  pricingData,
  isPricingFetching,
  selectedProducts,
  handleOnSummaryClick,
  searchName,
  openingHours,
  discounts,
  handleShowPickUpAndDropOffModal,
  showPickUpAndDropOffModal,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isMobile = useIsMobile();
  const supplierData = useSelector(getSupplierData);
  const isModoMonoActive = isModoMono(supplierData?._id);
  const { pickUpBranch } = useSelector(getBranchSelected, shallowEqual);
  const dates = useSelector((state) => getSearchValueByKey(state, "dates"));
  const [activedCategory, setActivatedCategory] = useState(null);
  const [hoursToOpen, setHoursToOpen] = useState(0);

  useEffect(() => {
    if (categories && categories.length > 0 && !activedCategory) {
      setActivatedCategory("all");
    }
  }, [categories]);

  const handleChange = (value) => {
    dispatch(setSearchByName(value));
  };

  useEffect(() => {
    if (quoteSummary.period === PERIODS.hour) {
      const fromHours =
        JSON.parse(openingHours)[
          `hours_${renderCustomFormatDate(
            dates.from,
            "dddd"
          ).toLocaleLowerCase()}`
        ];
      const actualTime = moment();
      const closedTime = moment(fromHours[0].to, "HH:mm");
      let timeDifference = actualTime.diff(closedTime, "hours");
      let hours;
      if (isRental(supplierData._id, RENTALS.ananda)) {
        hours = 0;
      } else {
        hours = 1;
      }
      timeDifference >= hours &&
        dispatch(
          modifyValueSearch("dates", {
            from: addDays(new Date(), 1),
            to: addDays(new Date(), 1),
          })
        );
      setHoursToOpen(timeDifference);
    }
  }, [quoteSummary?.period]);

  const handleOnCategoryActivity = (category) => {
    setActivatedCategory(category);
    trackEvent(clickEvents.SELECT_CATEGORY, {
      page: "Shop",
      category: category,
      supplierId: supplierData._id,
      supplierName: supplierData.name,
    });
    const element = document.getElementById(category);
    if (element) {
      // 👇 Will scroll smoothly to the top of the next section
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    }
  };

  const handleOnActionClick = () => {
    trackEvent(clickEvents.NAVIGATE_ADD_MEMBERS, {
      page: "Shop",
      supplierId: supplierData._id,
      supplierName: supplierData.name,
    });
    handleOnSummaryClick();
  };

  if (isLoading) {
    return (
      <SkeletonContainer>
        <Skeleton active />
        <Skeleton active />
        <Skeleton active />
        <Skeleton active />
        <Skeleton active />
      </SkeletonContainer>
    );
  }

  const renderEmpty = () => {
    if (isEmpty(productsByCategory)) {
      return (
        <SkeletonContainer>
          <NoProductsContainer>
            <Paragraph>
              {isModoMonoActive && !pickUpBranch?._id
                ? t("selectPickupBranch")
                : `${t("noEquipmentForActivity")} ${searchName}`}
            </Paragraph>
          </NoProductsContainer>
        </SkeletonContainer>
      );
    }
  };
  const renderSearch = () => {
    return <SearchBarProducts handleChange={handleChange} />;
  };

  return (
    <Container>
      <DateInputContainer
        period={quoteSummary.period}
        hoursToOpen={hoursToOpen}
        handleShowPickUpAndDropOffModal={handleShowPickUpAndDropOffModal}
        showPickUpAndDropOffModal={showPickUpAndDropOffModal}
      />
      <ProductList
        categories={categories}
        handleOnCategoryActivity={handleOnCategoryActivity}
        activedCategory={activedCategory}
        productsByCategory={productsByCategory}
        renderSearch={renderSearch}
        isMobile={isMobile}
        renderEmpty={renderEmpty}
        handleOnSubstractProduct={handleOnSubstractProduct}
        handleOnAddProduct={handleOnAddProduct}
        handleOnDetailsClick={handleOnDetailsClick}
        isClosed={isClosed}
        quoteSummary={quoteSummary}
        itemsLength={itemsLength}
        handleOnActionClick={handleOnActionClick}
        pricingData={pricingData}
        selectedProducts={selectedProducts}
        isPricingFetching={isPricingFetching}
        discounts={discounts}
      />
    </Container>
  );
};

export default ProductContainer;
